export default {
  computed: {
    isFullPageModal() {
      return this.$route.query.modal === "1";
    },
  }
}
